var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-block"},[_c('h2',{staticClass:"mb-4"},[_vm._v(" Gallery ")]),_c('p',[_vm._v(_vm._s(_vm.description))]),_c('gallery-widget',{attrs:{"images":_vm.preparedImages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }